class BookingManagerPopup {
    constructor(productData, testMode = false) {
        this.testMode = testMode;
        this.API_URL = 'https://user-api.simplybook.it';
        this.config = {
            token: '',
            studioData: null,
            selectedDate: null,
            selectedTime: null,
            units: [],
            bookingData: {
                eventId: null,
                unitGroupId: null,
                unitId: null,
            },
            product: productData,
        };

        this.selectedDate = null;
        this.workingDays = {};

        this.urlParams = new URLSearchParams(window.location.search);
        this.studioParam = this.urlParams.get('studio');
        this.isDiagnosticMode = this.urlParams.get('code') === 'free-diag';
        this.currentDisplayDate = new Date();

        this.calendar = document.getElementById('calendar');
        this.timeSlots = document.getElementById('timeSlots');

        this.init();
    }

    async init() {
        // Afficher le calendrier initial désactivé
        this.renderInitialCalendar();

        this.initEventListeners();
        this.initExtraListeners();
        this.attachCalendarListeners();
    }

    // Nouvelle méthode pour afficher le calendrier initial désactivé
    renderInitialCalendar() {
        if (!this.calendar) return;

        // Définir les limites de navigation pour l'affichage initial
        this.minDate = new Date(this.currentDisplayDate.getFullYear(), this.currentDisplayDate.getMonth(), 1);
        this.maxDate = new Date(this.currentDisplayDate.getFullYear(), this.currentDisplayDate.getMonth() + 2, 1);

        // Mettre à jour le mois affiché
        const monthDisplay = document.getElementById('currentMonth');
        if (monthDisplay) {
            monthDisplay.textContent = this.currentDisplayDate.toLocaleDateString('fr-FR', {
                month: 'long',
                year: 'numeric',
            });
        }

        // Générer le HTML du calendrier avec tous les jours désactivés
        const html = this.generateDisabledCalendarHTML(this.currentDisplayDate);
        this.calendar.innerHTML = html;

        // Désactiver les boutons de navigation
        const prevButton = document.getElementById('prevMonth');
        const nextButton = document.getElementById('nextMonth');

        if (prevButton && nextButton) {
            prevButton.disabled = true;
            prevButton.classList.add('tw-opacity-50');

            nextButton.disabled = true;
            nextButton.classList.add('tw-opacity-50');
        }
    }

    // Nouvelle méthode pour générer un calendrier entièrement désactivé
    generateDisabledCalendarHTML(date) {
        const year = date.getFullYear();
        const month = date.getMonth();
        const firstDay = new Date(year, month, 1);
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        let startDay = firstDay.getDay() - 1;
        if (startDay === -1) startDay = 6;

        const weekDays = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

        let html = `
    <div class="tw-w-full">
        <div class="tw-grid tw-grid-cols-7 tw-text-center tw-mb-2">
            ${weekDays.map(day => `
                <div class="tw-text-sm">${day}</div>
            `).join('')}
        </div>
        
        <div class="tw-grid tw-grid-cols-7 tw-gap-0.5 tw-text-center">
            ${Array(startDay).fill().map(() => `
                <div class="tw-p-2"></div>
            `).join('')}
            
            ${Array(daysInMonth).fill().map((_, index) => {
            const day = index + 1;
            const currentDate = new Date(year, month, day);
            const dateString = this.formatDate(currentDate);

            return `
                <button 
                    class="tw-p-2 tw-w-full tw-transition-colors tw-text-gray-300 tw-cursor-not-allowed"
                    data-date="${dateString}"
                    disabled
                >
                    ${day}
                </button>`;
        }).join('')}
        </div>
    </div>`;

        return html;
    }

    resetUIElements() {
        this.resetErrorMessageBook();
        // Réinitialiser le calendrier
        if (this.calendar) {
            this.calendar.innerHTML = '';
        }

        // Réinitialiser les créneaux horaires
        if (this.timeSlots) {
            this.timeSlots.innerHTML = '';
        }

        const bookButton = document.querySelector('.confirm-to-book');
        if (bookButton) {
            bookButton.disabled = true;
            bookButton.classList.add('tw-opacity-50');

            const content = bookButton.querySelector('.cta-content');
            const loader = bookButton.querySelector('.cta-loader');

            if (content) content.classList.remove('tw-opacity-0');
            if (loader) loader.classList.add('tw-hidden');
        }

        this.selectedDate = null;
        this.config.selectedDate = null;
        this.config.selectedTime = null;
        this.config.bookObj = {
            date: null,
            time: null
        };
    }

    initEventListeners() {
        const studioSelect = document.getElementById('studioSelect');
        if (studioSelect) {
            studioSelect.addEventListener('change', (e) => this.handleStudioSelection(e));

            if (studioSelect.value) {
                studioSelect.dispatchEvent(new Event('change'));
            }
        }
    }

    initExtraListeners() {
        const extraInputs = document.querySelectorAll('input[name="variant-selection"]');
        const bookButton = document.querySelector('#bookingPopup .confirm-to-book');
        const variantLabels = document.querySelectorAll('.booking-section--label-variant');
        const ctaPrice = document.querySelector('#bookingPopup .cta-content span[data-cta-product-price]');

        if (this.isDiagnosticMode && ctaPrice) {
            ctaPrice.innerHTML = '0€';
        }

        // Gestion des radios et mise à jour des événements
        extraInputs.forEach(input => {
            input.addEventListener('change', async (e) => {
                this.resetErrorMessageBook();
                const selectedSku = e.target.dataset.productSku;
                const selectedVariantId = e.target.dataset.variantId;
                const selectedVariantPrice = e.target.dataset.variantPrice;
                // Mettre à jour le SKU du bouton de réservation
                if (bookButton) {
                    bookButton.dataset.productSku = selectedSku;
                    bookButton.dataset.productId = selectedVariantId;
                    ctaPrice.textContent = selectedVariantPrice
                }
                // Mettre à jour le SKU dans la configuration
                if (this.config.product) {
                    this.config.product.sku = selectedSku;
                    this.config.product.id = selectedVariantId;
                }
                if (this.config.studioData && this.config.studioData.token) {
                    try {
                        // Récupérer la nouvelle liste d'événements avec le nouveau SKU
                        await this.updateEventId();
                        // Recharger les créneaux si une date est sélectionnée
                        if (this.selectedDate) {
                            await this.getPlaceDay();
                        }
                    } catch (error) {
                        console.error('Erreur lors de la mise à jour des événements:', error);
                    }
                }
            });
        });

        const studioSelect = document.getElementById('studioSelect');
        if (studioSelect && studioSelect.value) {
            const selectedOption = studioSelect.options[studioSelect.selectedIndex];
            this.updateVariantsVisibility(selectedOption.dataset.key);
        }

        // Gestion de l'affichage/masquage des descriptions
        let currentlyOpenLabel = null; // Pour garder une référence à l'élément actuellement ouvert

        variantLabels.forEach(label => {
            label.addEventListener('click', (e) => {
                // Évite d'interférer avec le clic sur le radio button
                if (e.target.type === 'radio') return;

                const description = label.querySelector('.variant-description');
                const extra = document.querySelector('#extra');
                const arrow = label.querySelector('svg');
                const isExpanded = label.getAttribute('aria-expanded') === 'true';

                // Si on clique sur un label différent, fermer le précédent
                if (currentlyOpenLabel && currentlyOpenLabel !== label) {
                    const prevDescription = currentlyOpenLabel.querySelector('.variant-description');
                    const prevArrow = currentlyOpenLabel.querySelector('svg');

                    currentlyOpenLabel.setAttribute('aria-expanded', 'false');
                    prevDescription?.classList.add('tw-hidden');
                    currentlyOpenLabel.style.maxHeight = '43px';
                    prevDescription.style.display = 'none';
                    if (prevArrow) {
                        prevArrow.style.transform = '';
                    }
                }

                // Toggle la description actuelle
                label.setAttribute('aria-expanded', !isExpanded);
                description?.classList.toggle('tw-hidden');

                if (isExpanded) {
                    label.style.maxHeight = '43px';
                    description.style.display = 'none';
                    extra.classList.add('tw-auto-rows-fr');
                    currentlyOpenLabel = null; // Réinitialiser la référence
                } else {
                    description.style.display = 'block';
                    label.style.maxHeight = `100%`;
                    extra.classList.remove('tw-auto-rows-fr');
                    currentlyOpenLabel = label; // Sauvegarder la référence
                }

                if (arrow) {
                    arrow.style.transform = isExpanded ? '' : 'rotate(-90deg)';
                }
            });
        });
    }

    async handleStudioSelection(event) {
        const selected = event.target.options[event.target.selectedIndex];
        if (!selected) return;

        this.resetUIElements();
        this.resetErrorMessageBook();

        this.config.studioData = {
            login: selected.dataset.login,
            apiKey: selected.dataset.key,
            unitGroupId: selected.dataset.idLocation,
            studioName: selected.textContent,
        };

        this.updateVariantsVisibility(selected.dataset.key);

        if (this.config.studioData.studioName.includes('Lafayette')) {
            window.location.href = 'https://wellness.galerieslafayette.com/marques/seasonly';
            return;
        }

        this.workingDays = {};
        this.currentDisplayDate = new Date();

        await this.connectToSimplybook();
    }

    updateVariantsVisibility(selectedStudioKey) {
        const variants = document.querySelectorAll('input[name="variant-selection"]:not([data-product-sku="SOIN_1H"])');

        variants.forEach(input => {
            const variantContainer = input.closest('.booking-section--label-variant') || input.closest('.booking-input-min-size');

            const variantStudios = input.dataset.variantStudios ?
                JSON.parse(input.dataset.variantStudios) : [];

            const isAvailable = variantStudios.includes(selectedStudioKey);
            variantContainer.style.display = isAvailable ? 'block' : 'none';
        });
    }

    async connectToSimplybook() {
        const result = await fetch('https://user-api.simplybook.it/login', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                jsonrpc: '2.0',
                method: 'getToken',
                id: Math.round(new Date().getTime() / 1000),
                params: {
                    companyLogin: this.config.studioData.login,
                    apiKey: this.config.studioData.apiKey,
                },
            }),
        });
        const token = await result.json();
        this.config.studioData.token = token.result;
        this.getEventList(this.config.studioData.token);
    }

    async updateEventId() {
        const result = await fetch('https://user-api.simplybook.it', {
            method: 'POST',
            headers: {
                'X-Company-Login': this.config.studioData.login,
                'X-Token': this.config.studioData.token,
            },
            body: JSON.stringify({
                jsonrpc: '2.0',
                method: 'getEventList',
                id: Math.round(new Date().getTime() / 1000),
                params: [],
            }),
        });
        const eventsList = await result.json();
        this.config.studioData.eventId = this.findEventIdBySku(eventsList.result, this.config.product.sku);
    }

    async getEventList() {
        await this.updateEventId();
        await this.getLocations();
    }

    async getLocations() {
        const result = await fetch('https://user-api.simplybook.it', {
            method: 'POST',
            headers: {
                'X-Company-Login': this.config.studioData.login,
                'X-Token': this.config.studioData.token,
            },
            body: JSON.stringify({
                jsonrpc: '2.0',
                method: 'getLocationsList',
                id: Math.round(new Date().getTime() / 1000),
                params: [],
            }),
        });
        const locs = await result.json();
        var locations = this.sortLocPos(locs.result);
        Object.entries(locations).forEach(([index, loc]) => {
            if (typeof this.config.units[loc.id] == 'undefined') {
                this.config.units[loc.id] = [];
            }
            loc.units.forEach((u) => {
                this.config.units[loc.id].push(parseInt(u));
            });
        });
        await this.getReservedTime();
    }

    async getReservedTime() {
        const today = new Date();
        const baseMonth = new Date(today.getFullYear(), today.getMonth(), 1);

        // Mois actuel
        const month = baseMonth.getMonth() + 1;
        const year = baseMonth.getFullYear();

        // Mois suivants
        const { nextMonth, nextYear } = this.getNextMonth(month, year);

        const { nextMonth: nextNextMonth, nextYear: nextNextYear } = this.getNextMonth(nextMonth, nextYear);

        // Chargement des trois mois
        const [currentMonthData, nextMonthData, nextNextMonthData] = await Promise.all([
            this.fetchMonthData(year, month),
            this.fetchMonthData(nextYear, nextMonth),
            this.fetchMonthData(nextNextYear, nextNextMonth)
        ]);

        // Réinitialiser et stocker les données
        this.workingDays = {
            ...currentMonthData,
            ...nextMonthData,
            ...nextNextMonthData,
        };

        // Stocker les limites de navigation
        this.minDate = baseMonth; // Premier jour du mois actuel
        // Définir maxDate comme le premier jour du mois après les deux mois suivants
        this.maxDate = new Date(nextNextYear, nextNextMonth - 1, 1);

        this.renderCalendar();
    }

    getNextMonth(month, year) {
        let nextMonth = month + 1;
        let nextYear = year;
        if (nextMonth > 12) {
            nextMonth = 1;
            nextYear++;
        }
        return { nextMonth, nextYear };
    }

    async fetchMonthData(year, month) {
        const result = await fetch(this.API_URL, {
            method: 'POST',
            headers: {
                'X-Company-Login': this.config.studioData.login,
                'X-Token': this.config.studioData.token,
            },
            body: JSON.stringify({
                jsonrpc: '2.0',
                method: 'getWorkCalendar',
                id: Math.round(Date.now() / 1000),
                params: { year, month },
            }),
        });
        const data = await result.json();
        return data.result;
    }

    async getPlaceDay() {
        try {
            const result = await fetch('https://user-api.simplybook.it', {
                method: 'POST',
                headers: {
                    'X-Company-Login': this.config.studioData.login,
                    'X-Token': this.config.studioData.token,
                },
                body: JSON.stringify({
                    jsonrpc: '2.0',
                    method: 'getStartTimeMatrix',
                    id: Math.round(Date.now() / 1000),
                    params: {
                        from: this.config.bookObj.date,
                        to: this.config.bookObj.date,
                        eventId: this.config.studioData.eventId,
                        unitId: this.config.units[this.config.studioData.unitGroupId],
                        count: 1,
                    },
                }),
            });

            const data = await result.json();
            const places = data.result;

            if (places && places[this.config.bookObj.date]?.length > 0) {
                const availableSlots = places[this.config.bookObj.date];
                const validSlots = this.validateSlots(
                    availableSlots,
                    this.config.studioData.login,
                    this.config.studioData.unitGroupId,
                    this.selectedDate
                );
                this.displayTimeSlots(validSlots);
            } else {
                this.displayNoAvailabilityMessage();
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des horaires:', error);
            // document.querySelector('.content-horaires').innerHTML =
            //     'Une erreur est survenue lors de la récupération des horaires.';
        }
    }

    validationHoraire(time, login, location, day) {
        const timeFixed = new Set([
            "10:00:00", "10:45:00", "11:30:00", "12:15:00",
            "13:00:00", "13:45:00", "14:45:00", "15:30:00",
            "16:15:00", "17:00:00", "17:45:00", "18:30:00",
            "19:15:00"
        ]);

        const timeFixedSaturday = new Set([
            "09:15:00", "10:00:00", "10:45:00", "11:30:00",
            "12:15:00", "13:00:00", "13:45:00", "14:45:00",
            "15:30:00", "16:15:00", "17:00:00", "17:45:00",
            "18:30:00", "19:15:00"
        ]);

        // Vérifier si c'est un samedi pour Seasonly ou SeasonlyPassy
        const isSaturdaySchedule = day === "Sat" &&
            location === "1" &&
            ["seasonly", "seasonlypassy"].includes(login);

        return isSaturdaySchedule ? timeFixedSaturday : timeFixed;
    }

    validateSlots(availableSlots, login, location, dayString) {
        const validTimeSlots = this.validationHoraire(null, login, location, dayString);
        return availableSlots.filter(slot => validTimeSlots.has(slot));
    }

    renderCalendar() {
        const calendarEl = document.querySelector('#calendar');
        if (!calendarEl) return;

        // Mise à jour du mois affiché
        const monthDisplay = document.getElementById('currentMonth');
        if (monthDisplay) {
            monthDisplay.textContent = this.currentDisplayDate.toLocaleDateString('fr-FR', {
                month: 'long',
                year: 'numeric',
            });
        }

        // Gérer l'état des boutons de navigation
        const prevButton = document.getElementById('prevMonth');
        const nextButton = document.getElementById('nextMonth');

        if (prevButton && nextButton) {
            const displayedMonth = new Date(this.currentDisplayDate.getFullYear(), this.currentDisplayDate.getMonth(), 1);

            prevButton.disabled = displayedMonth <= this.minDate;
            prevButton.classList.toggle('tw-opacity-50', displayedMonth <= this.minDate);

            nextButton.disabled = displayedMonth >= this.maxDate;
            nextButton.classList.toggle('tw-opacity-50', displayedMonth >= this.maxDate);
        }

        const html = this.generateCalendarHTML(this.currentDisplayDate);
        calendarEl.innerHTML = html;
    }

    generateCalendarHTML(date) {
        const year = date.getFullYear();
        const month = date.getMonth();
        const firstDay = new Date(year, month, 1);
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        let startDay = firstDay.getDay() - 1;
        if (startDay === -1) startDay = 6;

        const weekDays = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

        let html = `
    <div class="tw-w-full">
        <div class="tw-grid tw-grid-cols-7 tw-text-center tw-mb-2">
            ${weekDays.map(day => `
                <div class="tw-text-sm">${day}</div>
            `).join('')}
        </div>
        
        <div class="tw-grid tw-grid-cols-7 tw-gap-0.5 tw-text-center">
            ${Array(startDay).fill().map(() => `
                <div class="tw-p-2"></div>
            `).join('')}
            
            ${Array(daysInMonth).fill().map((_, index) => {
            const day = index + 1;
            const currentDate = new Date(year, month, day);
            const dateString = this.formatDate(currentDate);
            const isDisabled = this.workingDays[dateString]?.is_day_off === '1';
            const isSelected = this.selectedDate === dateString;

            return `
                <button 
                    class="tw-p-2 tw-w-full tw-transition-colors
                        ${isDisabled
                    ? 'tw-text-gray-300 tw-cursor-not-allowed'
                    : isSelected
                        ? 'tw-rounded tw-font-bold tw-border tw-border-black tw-border-solid tw-text-white tw-bg-black'
                        : 'hover:tw-bg-gray-100'
                }"
                    data-date="${dateString}"
                    ${isDisabled ? 'disabled' : ''}
                >
                    ${day}
                </button>`;
        }).join('')}
        </div>
    </div>`;

        return html;
    }

    formatDate(date) {
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${date.getFullYear()}-${month}-${day}`;
    }

    attachCalendarListeners() {
        // Navigation entre les mois
        document.getElementById('prevMonth').addEventListener('click', () => {
            this.navigateMonth(-1);
        });

        document.getElementById('nextMonth').addEventListener('click', () => {
            this.navigateMonth(1);
        });

        // Sélection d'une date
        document.getElementById('calendar').addEventListener('click', (e) => {
            if (e.target.matches('button[data-date]') && !e.target.disabled) {
                const dateString = e.target.dataset.date;
                this.selectedDate = dateString;
                this.handleDateSelection(new Date(dateString));
                this.renderCalendar();
            }
        });
    }


    async navigateMonth(direction) {
        // Ne rien faire si aucun studio n'est sélectionné
        if (!this.config.studioData) {
            return;
        }

        const timeSlots = document.getElementById('timeSlots');
        if (timeSlots) {
            while (timeSlots.firstChild) {
                timeSlots.removeChild(timeSlots.firstChild);
            }
        }

        const newDate = new Date(this.currentDisplayDate);
        newDate.setMonth(newDate.getMonth() + direction);

        const newMonthStart = new Date(newDate.getFullYear(), newDate.getMonth(), 1);

        if (newMonthStart < this.minDate || newMonthStart.getTime() > this.maxDate.getTime()) {
            return;
        }

        this.currentDisplayDate = newDate;
        this.renderCalendar();
    }

    handleDateSelection(date) {

        this.resetErrorMessageBook();

        const dateString = this.formatDate(date);

        this.config.bookObj = this.config.bookObj || {};
        this.config.bookObj.date = dateString;

        this.getPlaceDay();
    }

    generateTimeSlots(startTime, endTime) {
        const slots = [];
        const interval = 30;

        let currentTime = new Date(`2000-01-01T${startTime}`);
        const endDateTime = new Date(`2000-01-01T${endTime}`);

        while (currentTime < endDateTime) {
            slots.push(
                currentTime.toLocaleTimeString('fr-FR', {
                    hour: '2-digit',
                    minute: '2-digit',
                })
            );
            currentTime.setMinutes(currentTime.getMinutes() + interval);
        }

        return slots;
    }

    displayTimeSlots(slots) {
        let timeSlotsContainer = document.getElementById('timeSlots');
        if (!timeSlotsContainer) {
            timeSlotsContainer = document.createElement('div');
            timeSlotsContainer.id = 'timeSlots';
            timeSlotsContainer.className = 'tw-grid tw-grid-cols-5 md:tw-grid-cols-6 tw-gap-2 booking-input-min-size';
            document.getElementById('calendar').after(timeSlotsContainer);
        }

        timeSlotsContainer.className = 'tw-grid tw-grid-cols-5 md:tw-grid-cols-6 tw-gap-2 booking-input-min-size'

        timeSlotsContainer.innerHTML = slots
            .map(
                (time) => `
        <button 
          class="time-slot tw-p-2 tw-bg-white tw-border tw-border-black tw-border-solid tw-rounded hover:tw-bg-gray-100"
          data-time="${time}"
        >
          ${time.substring(0, 5)}
        </button>
      `
            )
            .join('');

        const timeButtons = timeSlotsContainer.querySelectorAll('button');
        timeButtons.forEach(button => {
            button.addEventListener('click', () => {
                // Réinitialiser tous les boutons
                timeButtons.forEach(btn => {
                    btn.classList.remove('tw-font-bold', 'tw-bg-black', 'tw-text-white');
                    btn.classList.add('tw-bg-white', 'hover:tw-bg-gray-100');
                });

                // Mettre en évidence le bouton sélectionné
                button.classList.remove('tw-bg-white', 'hover:tw-bg-gray-100');
                button.classList.add('tw-font-bold', 'tw-border', 'tw-border-black', 'tw-border-solid', 'tw-bg-black', 'tw-text-white');

                const selectedTime = button.dataset.time;
                this.handleTimeSelection(selectedTime);
            });
        });
    }



    handleTimeSelection(time) {
        this.config.bookObj.time = time;

        if (this.isDiagnosticMode && document.getElementById('customerInfoForm')) {
            document.getElementById('customerInfoForm').classList.remove('tw-hidden');
        }

        const bookButton = document.querySelector('.confirm-to-book');
        if (bookButton) {
            // Supprimer tous les anciens event listeners
            const newBookButton = bookButton.cloneNode(true);
            bookButton.parentNode.replaceChild(newBookButton, bookButton);

            newBookButton.disabled = false;
            newBookButton.classList.remove('tw-opacity-50');

            if (this.isDiagnosticMode) {
                this.validateCustomerForm(newBookButton);
            }

            // Ajouter un seul nouveau event listener
            newBookButton.addEventListener('click', (e) => {
                e.preventDefault();
                const content = newBookButton.querySelector('.cta-content');
                const loader = newBookButton.querySelector('.cta-loader');

                // Active l'état de chargement
                newBookButton.disabled = true;
                content.classList.add('tw-opacity-0');
                loader.classList.remove('tw-hidden');
                loader.firstElementChild.style.color = 'white';

                const target = e.target;
                const productData = {
                    id: target.dataset.productId,
                    title: target.dataset.productTitle,
                    price: target.dataset.productPrice,
                    sku: target.dataset.productSku,
                };

                // Ajouter un debounce pour s'assurer qu'un seul appel est fait
                if (!this._bookingInProgress) {
                    this._bookingInProgress = true;
                    this.bookSoin(this.studioParam)
                        .finally(() => {
                            this._bookingInProgress = false;
                            newBookButton.disabled = false;
                            content.classList.remove('tw-opacity-0');
                            loader.classList.add('tw-hidden');
                            loader.firstElementChild.style.color = 'black';
                        });
                }
            });
        }
    }

    displayNoAvailabilityMessage() {
        let timeSlotsContainer = document.getElementById('timeSlots');
        if (!timeSlotsContainer) {
            timeSlotsContainer = document.createElement('div');
            timeSlotsContainer.id = 'timeSlots';
            timeSlotsContainer.className = 'tw-mt-4 tw-text-center tw-text-gray-600';
            document.getElementById('calendar').after(timeSlotsContainer);
        }
        timeSlotsContainer.className = '';
        timeSlotsContainer.innerHTML = "Désolé, il n'y a plus de créneau disponible pour cette date.";
    }

    displayErrorMessage() {
        let timeSlotsContainer = document.getElementById('timeSlots');
        if (!timeSlotsContainer) {
            timeSlotsContainer = document.createElement('div');
            timeSlotsContainer.id = 'timeSlots';
            timeSlotsContainer.className = 'tw-mt-4 tw-text-center tw-text-red-600';
            document.getElementById('calendar').after(timeSlotsContainer);
        }
        timeSlotsContainer.className = '';
        timeSlotsContainer.innerHTML = 'Une erreur est survenue lors de la récupération des horaires.';
    }

    sortLocPos(localisations) {
        var localisationsSort = [];
        Object.entries(localisations).forEach(([index, loc]) => {
            localisationsSort[loc.position] = loc;
        });
        return localisationsSort;
    }

    findEventIdBySku(events, targetSku) {
        return (
            Object.entries(events).find(([_, event]) => {
                if (!event.description) return false;

                const skuText = event.description
                    .replace(/<p>|<\/p>|<br>|<br\/>/g, '')
                    .trim();

                return skuText.toLowerCase() === targetSku.toLowerCase();
            })?.[0] || null
        );
    }


    resetErrorMessageBook() {
        const errorSection = document.querySelector('.booking-section-error');
        if (errorSection) {
            errorSection.style.display = 'none';
            const errorText = errorSection.querySelector('.text-error');
            if (errorText) {
                errorText.innerHTML = '';
            }
        }
    }
    displayErrorMessageBook() {
        document.querySelector('.booking-section-error').style.display = 'flex';
        document.querySelector('.booking-section-error .text-error').innerHTML = 'Une erreur est survenue, veuillez réessayer dans quelques minutes.';
    }


    validateCustomerForm(bookButton) {
        if (!this.isDiagnosticMode) return;

        // Désactiver le bouton par défaut
        bookButton.disabled = true;

        // Fonction pour vérifier tous les champs requis
        const validateFields = () => {
            const requiredInputs = document.querySelectorAll('#customerInfoForm input[required]');
            let isValid = true;

            // Vérifier que chaque champ requis est rempli
            requiredInputs.forEach(input => {
                if (!input.value || input.value.trim() === '') {
                    isValid = false;
                }

                // Validation spécifique pour l'email
                if (input.type === 'email' && input.value.trim()) {
                    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailPattern.test(input.value)) {
                        isValid = false;
                    }
                }
            });

            return isValid;
        };

        // Appliquer la validation initiale
        bookButton.disabled = !validateFields();

        // Ajouter des écouteurs d'événements pour la validation en temps réel
        const requiredInputs = document.querySelectorAll('#customerInfoForm input[required]');
        requiredInputs.forEach(input => {
            // Utiliser 'input' pour une validation en temps réel
            input.addEventListener('input', () => {
                const isValid = validateFields();
                bookButton.disabled = !isValid;
            });

            // Ajouter aussi 'blur' pour valider quand l'utilisateur quitte un champ
            input.addEventListener('blur', () => {
                if (!input.value || input.value.trim() === '') {
                    input.classList.add('tw-border-red-500');
                } else {
                    input.classList.remove('tw-border-red-500');
                }

                // Pour l'email, vérifier le format
                if (input.type === 'email' && input.value.trim()) {
                    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    if (!emailPattern.test(input.value)) {
                        input.classList.add('tw-border-red-500');
                    } else {
                        input.classList.remove('tw-border-red-500');
                    }
                }

                const isValid = validateFields();
                bookButton.disabled = !isValid;
            });
        });

        // Ajouter une validation au moment du clic sur le bouton
        const originalClickHandler = bookButton.onclick;
        bookButton.onclick = function (e) {
            if (!validateFields()) {
                e.preventDefault();
                e.stopPropagation();

                // Mettre en évidence les champs vides
                const requiredInputs = document.querySelectorAll('#customerInfoForm input[required]');
                requiredInputs.forEach(input => {
                    if (!input.value || input.value.trim() === '') {
                        input.classList.add('tw-border-red-500');
                    }
                });

                return false;
            }

            // Si tout est valide, appeler le gestionnaire d'origine
            if (originalClickHandler) {
                return originalClickHandler.call(this, e);
            }
        };
    }

    getCustomerFormData() {
        const email = document.getElementById('customer-email')?.value || '';
        const firstName = document.getElementById('customer-firstname')?.value || '';
        const lastName = document.getElementById('customer-lastname')?.value || '';
        const phone = document.getElementById('customer-phone')?.value || '';
        const countryCode = document.getElementById('customer-country')?.value || 'FR';

        return {
            email: email,
            first_name: firstName,
            last_name: lastName,
            default_address: {
                phone: phone,
                country_code: countryCode
            }
        };
    }

    displayDiagnosticConfirmation() {
        const confirmationDiv = document.querySelector('#bookingPopupContainer');
        confirmationDiv.innerHTML = `
    <div class="tw-bg-white tw-max-w-lg tw-w-full tw-p-8 tw-rounded-lg tw-text-center">
        <svg class="tw-mx-auto tw-text-green-500 tw-mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="64" height="64">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
        </svg>
        <h2 class="tw-text-2xl tw-font-bold tw-mb-4">Votre diagnostic a bien été réservé</h2>
        <p class="tw-mb-6">Nous avons bien enregistré votre rendez-vous. Vous recevrez bientôt un email de confirmation.</p>
        <button class="tw-bg-black tw-text-white tw-py-3 tw-px-6 tw-rounded-md tw-font-semibold tw-uppercase">Fermer</button>
    </div>
    `;

        const closeButton = confirmationDiv.querySelector('button');
        closeButton.addEventListener('click', () => {
            const popup = document.getElementById('bookingPopup');
            if (popup) {
                popup.classList.add('tw-hidden');
                document.body.style.overflow = '';

                setTimeout(() => {
                    popup.remove();
                }, 300);
            }
        });
    }


    async bookSoin(studioParam) {
        await this.getAvailableUnits();

        // S'assurer qu'on ne prend que le premier provider disponible
        if (this.config.unitAvailableToBook.length === 0) {
            this.displayErrorMessageBook();
            throw new Error('Aucun provider disponible');
        }

        const objBooking = {
            "start_datetime": this.config.bookObj.date + " " + this.config.bookObj.time,
            "provider_id": this.config.unitAvailableToBook[0],
            "service_id": this.config.studioData.eventId,
            "simplybookCompany": this.config.studioData.login
        };

        await this.setBook(objBooking, studioParam);
    }

    async setBook(obj, studioParam) {
        // Si en mode diagnostic, ajoutez les paramètres supplémentaires
        if (this.isDiagnosticMode) {
            const customerData = this.getCustomerFormData();
            obj.status = 'paid';
            obj.customer = customerData;
        }

        const config = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
            body: JSON.stringify(obj)
        };

        try {
            let response;
            if (this.testMode) {
                // Simuler un délai de réseau
                await new Promise(resolve => setTimeout(resolve, 500));

                // mock
                response = {
                    status: 'success',
                    message: {
                        id: 'mock-booking-' + Math.floor(Math.random() * 1000),
                        code: 'MOCK' + Date.now().toString().substring(5),
                        start_datetime: obj.start_datetime,
                        provider_id: obj.provider_id,
                        service_id: obj.service_id
                    }
                };

                console.log('[TEST MODE] Simulating booking API call:', obj);
                console.log('[TEST MODE] Mock response:', response);
            } else {
                const result = await fetch("https://api.seasonly.fr/simplybook/book", config);
                if (!result.ok) {
                    this.displayErrorMessageBook();
                    throw new Error(`Erreur de réservation: ${result.status}`);
                }
                response = await result.json();
            }


            if (!response) {
                this.displayErrorMessageBook();
                throw new Error('Réponse de réservation invalide');
            }

            if (this.isDiagnosticMode) {
                // Afficher un message de confirmation au lieu d'ajouter au panier
                this.displayDiagnosticConfirmation();
            } else {
                await this.addToCartAndCheckout(response);

                const updatedCart = await fetch(window.Shopify.routes.root + 'cart.js');
                if (!updatedCart.ok) {
                    throw new Error('Erreur lors de la récupération du panier');
                }
                const cartData = await updatedCart.json();

                document.dispatchEvent(new CustomEvent('theme:cart:change', {
                    detail: { cart: cartData },
                    bubbles: true
                }));

                const cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
                if (cartDrawer) {
                    cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', {
                        bubbles: true
                    }));
                } else {
                    console.warn('Cart drawer not found');
                }

                const popup = document.getElementById('bookingPopup');
                if (popup) {
                    popup.classList.add('tw-hidden');
                    document.body.style.overflow = '';
                    popup.remove();
                }

            }


        } catch (error) {
            this.displayErrorMessageBook();
            console.error("Erreur complète:", error);
        }
    }

    async getAvailableUnits() {
        const result = await fetch("https://user-api.simplybook.it", {
            method: "POST",
            headers: {
                'X-Company-Login': this.config.studioData.login,
                'X-Token': this.config.studioData.token
            },
            body: JSON.stringify({
                jsonrpc: "2.0",
                method: "getAvailableUnits",
                id: Math.round(new Date().getTime() / 1000),
                params: [
                    this.config.studioData.eventId,
                    this.config.bookObj.date + " " + this.config.bookObj.time,
                    1
                ]
            })
        });
        const call = await result.json();
        var availables = call.result;
        this.config.unitAvailableToBook = [];
        availables.forEach(av => {
            if (this.config.units[this.config.studioData.unitGroupId].includes(av)) {
                this.config.unitAvailableToBook.push(av.toString());
            }
        });
    }


    async addToCartAndCheckout(response) {
        let formData = {
            'items': [{
                'id': this.config.product.id,
                'quantity': 1,
                'properties': {
                    "bookingCode": response.message.code,
                    "bookingId": response.message.id,
                    "simplybookCompany": this.config.studioData.login,
                    "date": response.message.start_datetime,
                    "booked": new Date().getTime() + 15 * 60000,
                    "studio": this.config.studioData.studioName
                }
            }]
        };

        // Ajouter le produit dans le localstorage avec une expiration
        try {
            const expirationTime = Date.now() + 25 * 60 * 1000;
            localStorage.setItem(`cartItem_${this.config.product.id}`, JSON.stringify({
                expirationTime: expirationTime,
                lastChecked: Date.now()
            }));
        } catch (e) {
            console.error("Erreur lors de l'enregistrement dans localStorage:", e);
        }

        return fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });
    }
}